module.exports = __webpack_public_path__ + "2d73c057351c3a904804379b3e79efbb.mp4";